var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 1.675L12 3.45V1C12 0.734784 11.8946 0.48043 11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11V8.54L15.15 10.315C15.2308 10.3678 15.3241 10.3984 15.4205 10.4037C15.5169 10.4091 15.613 10.3889 15.6991 10.3453C15.7853 10.3018 15.8584 10.2363 15.9112 10.1555C15.964 10.0747 15.9947 9.98139 16 9.885V2.1C15.9938 2.00404 15.9626 1.91137 15.9095 1.83124C15.8563 1.75111 15.7831 1.68631 15.6971 1.6433C15.6111 1.6003 15.5153 1.5806 15.4193 1.58616C15.3233 1.59172 15.2305 1.62235 15.15 1.675Z",
    fill: "#62718A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVid);
export default __webpack_public_path__ + "static/media/vid.db4eaf3ff80e5e850a430ea83f7b8347.svg";
export { ForwardRef as ReactComponent };